import { Icon } from "@circle-react-shared/Icon";
import { useDisableWindowScroll } from "@circle-react-shared/TrixEditor/useDisableWindowScroll";
import { Portal } from "@circle-react-uikit/Portal";

export interface FullScreenLoaderProps {
  message?: string;
}

export const FullScreenLoader = ({ message = "" }: FullScreenLoaderProps) => {
  useDisableWindowScroll(true);

  return (
    <Portal className="react-loader react-fullscreen-loader">
      <div className="overlay">
        <div className="content">
          <Icon type="loader" />
          <div className="loader-message">{message}</div>
        </div>
      </div>
    </Portal>
  );
};
